import { render } from "./DictionaryValueList.vue?vue&type=template&id=7b696354"
import script from "./DictionaryValueList.vue?vue&type=script&lang=js"
export * from "./DictionaryValueList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__